module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-42LS9SDFK1"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"nfelo - predictive NFL analytics","short_name":"nfelo","start_url":"/","display":"standalone","icon":"src/assets/nfelo_favicon.png","background_color":"#ffffff","theme_color":"#ffffff","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0e2af35e7f0aef1f2fe3b4562dc2c0a6"},
    }]
